const FIVE_MINUTES = 300000;

export const AUTH_COOKIES = ['sharewave_JWT', 'no_login', 'GEM_company'];

export function delete_cookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
}

export function set_cookie(name: string, value:any, expires = FIVE_MINUTES, path = '/') {
    let expiration_date = new Date();
    expiration_date.setTime(expiration_date.getTime() + expires);
    document.cookie = `${name}=${value}; expires=${expiration_date.toUTCString()}; path=${path}`;
}



// WEBPACK FOOTER //
// ./_src/services/sessionState/cookies.ts